// INIT SESSION (run once)
if (!localStorage.getItem('bc_session')) {
  localStorage.setItem('bc_session', 'sess_' + Date.now());
}

// FUNCTION
function handleDistanceCheck(product) {
  const origin = document.getElementById('origin').value;
  const destination = document.getElementById('destination').value;

  const payload = {
    product: product,
    origin: origin,
    destination: destination,
    page_url: window.location.href,
    session_id: localStorage.getItem('bc_session') || ''
  };

  // 🔴 LOGGING (no change)
  fetch("https://script.google.com/macros/s/AKfycbxugc9xD9tOt8Ll8fzAfC4zDY2EW5IzorLSfJwrIXNGkOveLWxypQv45FYaDy2iTdzIyQ/exec", {
    method: "POST",
    mode: "no-cors",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });

  // 🔴 OPEN GOOGLE MAPS (no change)
  const url = `https://www.google.com/maps/dir/?api=1&origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`;
  window.open(url, '_blank');

  // 🔴 FETCH DISTANCE DATA
  fetch(`https://script.google.com/macros/s/AKfycbxugc9xD9tOt8Ll8fzAfC4zDY2EW5IzorLSfJwrIXNGkOveLWxypQv45FYaDy2iTdzIyQ/exec?origin=${encodeURIComponent(origin)}&destination=${encodeURIComponent(destination)}`)
    .then(res => res.json())
    .then(data => {

      // 🔴 PARSE VALUES
      const distance = parseFloat(data.distance);
      const excess = parseFloat(data.excess);

      // 🔴 DETERMINE TRIP TYPE (EXCESS-BASED)
      let tripType = '';

      if (excess <= 50) {
        tripType = 'Within Metro Manila';
      } else if (excess <= 100) {
        tripType = 'Nearby Provinces';
      } else if (excess <= 200) {
        tripType = 'Regional Trips';
      } else if (excess <= 400) {
        tripType = 'Long Distance';
      } else {
        tripType = 'Extended Distance';
      }

      // 🔴 OUTPUT TEXT
      document.getElementById('distance-result').innerHTML =
        `Distance from pickup location to farthest point: ${distance.toFixed(2)} km<br>
         Base coverage: 50 km radius from pickup<br>
         Distance beyond 50 km radius: ${excess.toFixed(2)} km<br><br>
         <strong>Recommended trip type: ${tripType}</strong>`;

      // 🔴 HIDE HINT
      const hint = document.getElementById('distance-hint');
      if (hint) hint.style.display = 'none';

      // 🔴 UX: HIGHLIGHT + BADGE (FIXED — NO DUPLICATES)

      const options = document.querySelectorAll('.variant-option__button-label');

      // remove highlight
      options.forEach(el => {
        el.classList.remove('bc-trip-recommended');
      });

      // remove old badges
      document.querySelectorAll('.bc-recommended-badge').forEach(el => el.remove());

      // apply highlight + badge
      options.forEach(el => {
        const input = el.querySelector('input');

        if (input && input.value && input.value.includes(tripType)) {

          // highlight
          el.classList.add('bc-trip-recommended');

          // badge
          const badge = document.createElement('span');
          badge.className = 'bc-recommended-badge';
          badge.innerText = 'Recommended';

          el.appendChild(badge);
        }
      });

    });
}